<template>
	<div class="block ppc blue disabled">
		<router-link :to="{path: `/client/${getClientSlug}/ppc`}">
			<h3>PPC</h3>
			<div class="row">
				<p>Avg. Cost per click</p>
				<div class="stats">
					<p class="number">{{ perClick }}</p>
					<div class="conversion-rate up">
						<div class="grid-container">
							<div class="col">
								<p>{{ PerClickConversion }}</p>
							</div>
							<div class="col">
								<span class="arrow">
									<i class="fa-solid fa-arrow-up-long"></i>
								</span>
							</div>
						</div>
					</div>
					<!-- end conversion-rate -->
				</div>
				<!-- end stats -->
				<p class="dark">than last month</p>
			</div>
			<!-- end row -->
			<div class="row">
				<p>Conversions</p>
				<div class="stats">
					<p class="number">{{ conversionVal }}</p>
					<div class="conversion-rate down">
						<div class="grid-container">
							<div class="col">
								<p>{{ conversionRate }}</p>
							</div>
							<div class="col">
								<span class="arrow">
									<i class="fa-solid fa-arrow-up-long"></i>
								</span>
							</div>
						</div>
					</div>
					<!-- end conversion-rate -->
				</div>
				<!-- end stats -->
				<p class="dark">than last month</p>
			</div>
			<!-- end row -->
			<span class="arrow-link">PPC information</span>
		</router-link>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

let costPerClick = "£1.80"
let costPerClickConversion = "56.65%"

let conversions = "460"
let conversionPercent = "56.65%"

export default {
	data() {
		return {
			perClick: costPerClick === "" ? "--" : costPerClick,
			PerClickConversion: costPerClickConversion === "" ? "--" : costPerClickConversion,
			conversionVal: conversions === "" ? "--" : conversions,
			conversionRate: conversionPercent === "" ? "--" : conversionPercent,
		}
	},
	computed: {
		...mapGetters("client", ["getClientSlug"]),
	},
}
</script>
